import className from 'classnames';
import classNames from 'classnames';
import React, {Component} from 'react';

import {withI18n, WithI18nProps} from '@udemy/i18n';
import TrendingFlameIcon from '@udemy/icons/dist/trending-flame.ud-icon';
import TrendingGraphIcon from '@udemy/icons/dist/trending-graph.ud-icon';

import {Topic} from '../../types';
import styles from './featured-topic-card.module.less';

interface FeaturedTopicCardProps extends WithI18nProps {
    className?: string;
    pageType: string;
    topic: Topic;
    isLoading?: boolean;
    titleId?: string;
}

class FeaturedTopicCardClass extends Component<FeaturedTopicCardProps> {
    static defaultProps = {
        className: '',
        topic: {categoryUrl: '', categoryTitle: ''} as Topic,
        isLoading: false,
    };

    renderStat() {
        let icon, statText;
        const {gettext} = this.props;
        if (this.props.topic.type === 'trending') {
            statText = gettext('Trending topic');
            icon = (
                <TrendingFlameIcon
                    label={statText}
                    className={styles['topic-stat-icon-flame']}
                    size="medium"
                />
            );
        } else {
            const text = gettext('Popular in');
            icon = (
                <TrendingGraphIcon
                    label={text}
                    className={styles['topic-stat-icon-graph']}
                    size="medium"
                />
            );
            statText = (
                <div className={styles['popular-category']}>
                    {text}{' '}
                    <a href={this.props.topic.categoryUrl}>{this.props.topic.categoryTitle}</a>
                </div>
            );
        }

        // object used to nest two anchor tags
        return (
            <object data-testid="stats" className={styles['topic-stat-container']}>
                {icon}
                <span className={classNames('ud-text-sm', styles['topic-stat-text'])}>
                    {statText}
                </span>
            </object>
        );
    }

    render() {
        const containerClass = className({
            container: true,
        });

        if (this.props.isLoading) {
            return <div className={classNames(styles[containerClass], this.props.className)}></div>;
        }

        return (
            <a
                className={classNames(styles[containerClass], this.props.className)}
                href={`/topic/${this.props.topic.url}`}
            >
                <div
                    data-testid="image"
                    className={styles['image-container']}
                    style={{backgroundImage: `url(${this.props.topic.imageUrl})`}}
                />
                <div className={styles['item-details-container']}>
                    <div>
                        <div
                            id={this.props.titleId}
                            className={classNames('ud-text-lg', styles.title)}
                        >
                            {this.props.topic.title}
                        </div>
                        <div className={classNames('ud-text-md', styles.description)}>
                            {this.props.topic.description}
                        </div>
                    </div>
                    {this.renderStat()}
                </div>
            </a>
        );
    }
}

export const FeaturedTopicCard = withI18n(FeaturedTopicCardClass);
